export const getShortUrl = (videoId: string): string => `https://www.youtube.com/shorts/${videoId}`;

export const getShortThumbnailUrl = (videoId: string): string => `https://i.ytimg.com/vi/${videoId}/oar2.jpg`;

export const getShortFallbackThumbnailUrl = (videoId: string): string => `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
export const getShortUrl = (videoId: string): string => `https://www.youtube.com/shorts/${videoId}`;

export const getShortThumbnailUrl = (videoId: string): string => `https://i.ytimg.com/vi/${videoId}/oar2.jpg`;

export const getShortFallbackThumbnailUrl = (videoId: string): string => `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
